<template>
  <div class="hello">
    <!-- hi: {{slugTitle}}
    <hr />
    {{dataResponse}} -->
  </div>
</template>

<script>
import store from "@/store";
export default {
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      isLoading: false,
      slugTitle: this.$route.params.slug,
      dataResponse: {}
    };
  },
  async created() {
    this.pickOperatorBySlug();
  },
  methods: {
    pickOperatorBySlug() {
      // console.log("okeee");
      this.isLoading = true;
      let param = {
        header: {
          slug: this.$route.params.slug
        }
      };
      store
        .dispatch("toolkit/pickOperatorBySlug", param)
        .then(response => {
          this.isLoading = false;
          // console.log("xx");
          this.dataResponse = response;
          var { data } = response;
          window.location.href =
            "https://api.whatsapp.com/send?phone=" +
            data.phone_number +
            "&text=" +
            data.chat_content;
        })
        .catch(err => {
          console.log("err", err);

          this.isLoading = false;
          window.location.href = "https://waajo.id";
        });
      console.log("aa");
    }
  },
  mounted() {},
  name: "home"
};
</script>


// WEBPACK FOOTER //
// src/components/home/index.vue